import React from 'react';
import { withRouter } from 'react-router-dom';
import SegmentWrapper from './SegmentWrapper';
import { getSingleJob } from './SegmentWrapper';
import { trackViewJobsSearch } from './tracking';

const trackViewJob = () => {
  const jobId = window.location.href.match('(?<=detail/).*$')[0]

  if (jobId) {
    getSingleJob(jobId).then(singleJob => {
      singleJob = singleJob[0];
      let pro_only;
      let max_salary = '';
      let hourly_rate_range  = '';
      if (singleJob.applicant_group === 'PGA Professional Only') {
        pro_only = true;
      } else {
        pro_only = false;
      }
      
      if (singleJob.pay_schedule === 'Salary') {
        if (singleJob.base_compensation_max.value) {
          max_salary = singleJob.base_compensation_max.value;
        } else {
          max_salary = singleJob.base_compensation.value
        }

      } else {
        hourly_rate_range = singleJob.base_compensation.value;
      }

      window.analytics.track('View Job', {
          job_id: singleJob.jobId,
          job_location: singleJob.facilities[0].city + ', ' + singleJob.facilities[0].state,
          job_post_date: new Date(singleJob.created * 1000).toISOString(),
          job_deadline: new Date(singleJob.submission_deadline * 1000).toISOString(),
          job_position_type: singleJob.employment_type,
          job_minimum_experience: singleJob.years_experience,
          job_company: singleJob.offices[0].name,
          job_title: singleJob.jobTitle,
          job_additional_pga_education: singleJob.additional_pga_education,
          job_education_required: singleJob.education[0] || false,
          job_pga_pro_only: pro_only,
          job_max_salary: max_salary || 0,
          job_hourly_rate_range: hourly_rate_range || 0,
          page_url: window.location.href,
          page_path: window.location.pathname
      })
    });
  }
}


const trackPageViews = () => {
    if (window.location.href.includes('jobs') && window.location.href.includes('pga') &&
    window.location.href.includes('/detail/')) {
      trackViewJob();
    } else if (!window.location.href.includes('/search')) {
      window.analytics.page({
      page_path: window.location.pathname,
      page_url: window.location.href,
    });
    }
}

class RouteChangeHandler extends React.Component {

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      trackViewJobsSearch();
      if (!window.location.href.includes('search')) {
        trackPageViews();
      }
    }
  }

  componentDidMount() {
    trackPageViews();
    trackViewJobsSearch()
  }

  render() {
    return <SegmentWrapper/>;
  }
}

export default withRouter(RouteChangeHandler)
